import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Col, Form, Input, Row } from 'antd';
import { PrimaryButton, SecondaryButton } from './styles';

interface CommentFormProps {
	loading?: boolean;
	onCancel: () => void;
	onFinish: () => void;
}

export function CommentForm({ loading = false, onFinish, onCancel }: Readonly<CommentFormProps>): JSX.Element {
	return (
		<Col span={24}>
			<Form.Item name="comment" rules={[{ required: true, message: 'Please enter a description!' }]}>
				<Input.TextArea rows={4} placeholder={I18n.get('Description of the file')} />
			</Form.Item>
			<Form.Item>
				<Row justify="center" gutter={[20, 20]}>
					<Col>
						<SecondaryButton onClick={onCancel}>{I18n.get('Cancel')}</SecondaryButton>
					</Col>
					<Col>
						<PrimaryButton type="primary" onClick={onFinish} loading={loading}>
							{I18n.get('Save')}
						</PrimaryButton>
					</Col>
				</Row>
			</Form.Item>
		</Col>
	);
}
